import React, { createContext, useContext } from 'react';
export var VideoRoomI18nContext = createContext(null);
export var VideoRoomI18nMessage = {
  cta_mute_audio: {
    id: 'cta_mute_audio',
    "default": function _default() {
      return 'Mute Audio';
    }
  },
  cta_unmute_audio: {
    id: 'cta_unmute_audio',
    "default": function _default() {
      return 'Unmute Audio';
    }
  },
  cta_mute_video: {
    id: 'cta_mute_video',
    "default": function _default() {
      return 'Mute Video';
    }
  },
  cta_unmute_video: {
    id: 'cta_unmute_video',
    "default": function _default() {
      return 'Unmute Video';
    }
  },
  cta_bye: {
    id: 'cta_bye',
    "default": function _default() {
      return 'bye';
    }
  },
  cta_switch_camera: {
    id: 'cta_switch_camera',
    "default": function _default() {
      return 'Switch Camera';
    }
  },
  cta_start_screen_share: {
    id: 'cta_start_screen_share',
    "default": function _default() {
      return 'Share Screen';
    }
  },
  cta_stop_screen_share: {
    id: 'cta_stop_screen_share',
    "default": function _default() {
      return 'Stop Share Screen';
    }
  },
  screen_share_in_progress: {
    id: 'screen_share_in_progress',
    "default": function _default() {
      return 'Cannot share screen when another user is sharing';
    }
  },
  screen_share_not_supported: {
    id: 'screen_share_not_supported',
    "default": function _default() {
      return 'Screen sharing is not supported with this browser';
    }
  },
  remote_muted_audio: {
    id: 'remote_muted_audio',
    "default": function _default(_ref) {
      var name = _ref.name;
      return name + " is muted";
    }
  },
  remote_muted_video: {
    id: 'remote_muted_video',
    "default": function _default(_ref2) {
      var name = _ref2.name;
      return name + "'s camera is off";
    }
  },
  local_muted_audio: {
    id: 'local_muted_audio',
    "default": function _default() {
      return 'You are muted';
    }
  },
  local_muted_video: {
    id: 'local_muted_video',
    "default": function _default() {
      return 'Your camera is off';
    }
  },
  reconnecting: {
    id: 'reconnecting',
    "default": function _default() {
      return 'Reconnecting';
    }
  },
  end_call: {
    id: 'end_call',
    "default": function _default() {
      return 'End Call';
    }
  }
};
export default function VideoRoomI18nProvider(_ref3) {
  var children = _ref3.children,
      formatter = _ref3.formatter;

  var format = function format(message, params) {
    if (formatter) {
      try {
        return formatter({
          id: message.id,
          params: params
        });
      } catch (error) {
        console.error("VideoRoomI18nProvider " + message.id, error);
        return message["default"](params);
      }
    } else return message["default"](params);
  };

  return /*#__PURE__*/React.createElement(VideoRoomI18nContext.Provider, {
    value: {
      format: format
    }
  }, children);
}
export function useVideoRoomI18nProvider() {
  var context = useContext(VideoRoomI18nContext);

  if (!context) {
    throw new Error('useVideoRoomI18nProvider must be used within the scope of VideoRoomI18nContext');
  }

  return context;
}